<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-select v-model="query.type" @change="resetList" clearable placeholder="类型">
              <el-option label="工具" value="TOOL"></el-option>
              <el-option label="学习" value="LEARN"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.status" @change="resetList" clearable placeholder="状态">
              <el-option label="待审核" value="PENDING"></el-option>
              <el-option label="已通过" value="APPROVED"></el-option>
              <el-option label="已拒绝" value="REJECTED"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">查询</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="left" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" label="type" prop="type" width="140" />
        <el-table-column align="center" label="payType" prop="payType" width="140" />
        <el-table-column align="center" label="toolName" prop="toolName" width="180" />
        <el-table-column align="center" label="toolTitle" prop="toolTitle" width="250" />
        <el-table-column align="center" label="url" prop="url" width="250" />
        <el-table-column align="center" label="userId" prop="userId" width="250" />
        <el-table-column align="center" label="toolDesc" width="300">
          <template slot-scope="scope">
            <div style="max-height: 300px; overflow: auto">
              {{ scope.row.toolDesc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="320" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="scope.row.status"
                @change="onChangeStatus($event, scope.row.id)"
                placeholder="状态"
                size="mini"
              >
                <el-option label="待审核" value="PENDING"></el-option>
                <el-option label="已通过" value="APPROVED"></el-option>
                <el-option label="已拒绝" value="REJECTED"></el-option>
              </el-select>
              <div style="width: 10px; height: 1px"></div>
              <el-button @click="handleDelete(scope.row)" size="mini" type="danger">
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getSubmitList, updateSubmit, deleteSubmit } from '@/api/submit'
import { i18nConfig } from '@/utils'

export default {
  data() {
    return {
      i18nConfig,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        content: '',
        limit: 10,
        current: 1,
        status: 'PENDING',
        type: ''
      }
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    onChangeStatus(e, id) {
      this.handleUpdate({
        id,
        status: e
      }).finally(() => {
        this.listLoading = false
      })
    },

    handleDelete(row) {
      const { id } = row
      this.$confirm('是否删除提交', '提示', {}).then(() => {
        this.listLoading = true
        deleteSubmit(id)
          .then(() => {
            this.getList()
          })
          .finally(() => {
            this.listLoading = false
          })
      })
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        this.listLoading = true
        updateSubmit(row)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    resetList() {
      this.query.current = 1
      this.getList()
    },

    getList() {
      this.listLoading = true
      const form = JSON.parse(JSON.stringify(this.query))
      if (!form.type) {
        delete form.type
      }
      if (!form.status) {
        delete form.status
      }
      getSubmitList(this.query).then((res) => {
        this.list = res.result.rows
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>
